/* eslint-disable no-undef */
import React, { Component } from "react";
import axios from "axios";
import { List } from "react-content-loader";

import { locationCode, locationObject, pendingPaymentObject, tenantProfile } from "../../../Utils/Common";

import { logApiFail, logOpenEdgeRequest, logOpenEdgeResponse } from "../../../Utils/rollbar";
import { 
  getOrCreateOrderId, 
  createTransactionHistory, 
  updateTransactionStatus, 
  TRANSACTION_STATUS 
} from "../../../Utils/transactionStatus";
import withRetryPaymentCount from "../../HOC/withRetryPaymentCount";
import GoogleRecaptcha from "../../../shared/GoogleRecaptcha";
import CloudflareTurnstile from "../../../shared/CloudflareTurnstile";
import { useTurnstile } from "../../../Utils/captchaConfig";

class OnlinePaymentCard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      url: "",
      loading: false,
      autopay: sessionStorage.getItem("autopay_bit"),
      feeId: sessionStorage.getItem("cc_fee_id"),
      feeAmount: sessionStorage.getItem("cc_fee_amount"),
      leaseNumber: sessionStorage.getItem("selected_lease_number"),
      mylocation: locationObject(),
      captchaToken: null,
      captchaVerified: false,
      showCaptcha: true,
      captchaError: null,
    };
  }

  componentDidMount() {
    // Don't load payment form until captcha is verified
    if (typeof KioApp !== "undefined") {
      KioApp.StartKeyboard("", "", "number", false, "", "");
    }

    const listener = window.addEventListener("blur", () => {
      if (document.activeElement === document.querySelector("iframe")) {
        if (typeof KioApp !== "undefined") {
          KioApp.StartKeyboard("", "", "number", false, "", "");
        }
      }
      window.removeEventListener("blur", listener);
    });
  }

  componentWillUnmount() {
    if (typeof KioApp !== "undefined") {
      KioApp.CloseKeyboard();
    }
  }

  onCaptchaVerify = (token) => {
    this.setState({
      captchaToken: token,
      captchaVerified: true,
      captchaError: null,
      showCaptcha: false,
    });
    this.loadPaymentForm();
  };

  onCaptchaError = (err) => {
    console.error("reCAPTCHA error:", err);
    this.setState({
      captchaError: "Captcha verification failed. Please try again.",
      captchaVerified: false,
    });
  };

  loadPaymentForm = async () => {
    this.setState({ loading: true });

    const paymentObject = pendingPaymentObject();
    const profile = tenantProfile();
    if (!paymentObject) {
      alert("Failed to load payment data");
      this.props.history.push("/unit-lease-details");
      return;
    }

    let amount = Math.abs(parseFloat(paymentObject.rent));
    if (this.state.mylocation.cc_fee && this.state.autopay === "0") {
      amount += parseFloat(this.state.feeAmount);
    }

    sessionStorage.setItem('cc_fee_status', this.state.mylocation.cc_fee ? "1" : "0")

    // Generate or get order ID for transaction tracking
    const orderId = getOrCreateOrderId('existing_tenant_order_id');
    const loginObj = sessionObject();

    const payment = {
      location_code: locationCode(),
      total_amount: parseFloat(amount).toFixed(2),
      rent_amount: parseFloat(amount).toFixed(2),
      return_url: window.location.origin + "/online-confirm-payment",
      contact: profile,
      captcha_token: this.state.captchaToken, // Include captcha token
    };

    // Create transaction history record
    await createTransactionHistory({
      order_id: orderId,
      location_code: locationCode(),
      tenant_id: loginObj?.id || null,
      amount: parseFloat(amount).toFixed(2),
      payment_method: 'CC',
      payment_flow: 'existing_tenant_hosted',
      lease_number: paymentObject.leaseNumber,
    });

    // Update status to PENDING (iframe loaded, waiting for user)
    await updateTransactionStatus(orderId, TRANSACTION_STATUS.PENDING, {
      step: 'iframe_loaded',
      paypage_url_requested: true,
    });

    logOpenEdgeRequest("/api/paygateway/hostpay/transactions", payment);

    axios
      .post("/api/paygateway/hostpay/transactions", JSON.stringify(payment), {
        headers: { "Content-Type": "application/json" },
      })
      .then(async (response) => {
        logOpenEdgeResponse("/api/paygateway/hostpay/transactions", response.data, true);
        this.setState({
          url: response.data.paypageurl,
          loading: false,
        });
      })
      .catch(async (e) => {
        logOpenEdgeResponse("/api/paygateway/hostpay/transactions", e.response?.data || e.message, false);
        logApiFail("/paygateway/hostpay/transactions", payment, e);
        
        // Update status to FAILED
        await updateTransactionStatus(orderId, TRANSACTION_STATUS.FAILED, {
          step: 'openedge_iframe_request',
          error: e.response?.data || e.message,
        });

        // Extract error message from API response
        let errorMessage = "Payment gateway error. Please try again.";
        if (e.response && e.response.data) {
          if (e.response.data.error) {
            errorMessage = e.response.data.error;
          } else if (e.response.data.message) {
            errorMessage = e.response.data.message;
          }
        } else if (e.message) {
          errorMessage = e.message;
        }

        this.setState({
          loading: false,
          captchaError: errorMessage,
          showCaptcha: true,
          captchaVerified: false,
        });
      });
  };

  render() {
    return (
      <div className="wrapper">
        <link rel="stylesheet" href="/css/captcha.css" />
        <div className="container">
          <div className="row py-5">
            <div className="col-sm-12 col-md-8">
              {this.state.showCaptcha ? (
                <div className="captcha-container">
                  <div className="captcha-header">
                    <h4 className="captcha-title">Security Verification</h4>
                    <p className="captcha-description">
                      Please complete the security verification to proceed with your payment.
                    </p>
                  </div>
                  <div className="captcha-content">
                  {useTurnstile ? (
                      <CloudflareTurnstile
                        onVerify={this.onCaptchaVerify}
                        onError={this.onCaptchaError}
                        onExpire={this.onCaptchaError}
                        theme="auto"
                        size="normal"
                      />
                    ) : (
                      <GoogleRecaptcha
                        onVerify={this.onCaptchaVerify}
                        onError={this.onCaptchaError}
                      />
                    )}
                    {this.state.captchaError && (
                      <div className="captcha-error">
                        {this.state.captchaError}
                      </div>
                    )}
                  </div>
                </div>
              ) : this.state.loading ? (
                <List backgroundColor={"#ccc"} />
              ) : (
                <div>
                  <iframe title="Online Payment" className="paygateway-form" src={this.state.url} width="100%"></iframe>
                  <div className="credit-number-mask" />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const PAGE_ID = "exiting_payment_online_payment_card_retry_count";
const PAYMENT_METHOD_RETURN_URL = "/online-payment-method";
export default withRetryPaymentCount(OnlinePaymentCard, PAGE_ID, PAYMENT_METHOD_RETURN_URL, true);
